import type { RequestForQuoteQuery } from '@/suppliers/_gen/gql'

import { Table, Tbody, Td, Tr, Thead, Th } from '@/gf/components/Table'

type Rfq = Exclude<RequestForQuoteQuery['requestForQuote'], null>

const AccountMachinesTable = ({ accountMachines }: { accountMachines: Rfq['orgMachines'] }) => (
  <Table>
    <Thead>
      <Tr>
        <Th>Unit #</Th>
        <Th>Serial Number</Th>
        <Th>Make</Th>
        <Th>Model</Th>
        <Th>Year</Th>
        <Th>Engine Make</Th>
        <Th>Engine Model</Th>
        <Th>Engine Serial Number</Th>
      </Tr>
    </Thead>
    <Tbody>
      {accountMachines.map((accountMachine) => (
        <Tr key={accountMachine.name}>
          <Td>{accountMachine.name}</Td>
          <Td>{accountMachine.serialNumber}</Td>
          <Td>{accountMachine.machine.make}</Td>
          <Td>{accountMachine.machine.model}</Td>
          <Td>{accountMachine.machine.year}</Td>
          <Td>{accountMachine.engineMake}</Td>
          <Td>{accountMachine.engineModel}</Td>
          <Td>{accountMachine.engineSerialNumber}</Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
)

export default AccountMachinesTable
